import { createSlice } from "@reduxjs/toolkit";

const operatorSlice = createSlice({
  name: "operators",
  initialState: {
    users: "",
  },

  reducers: {
    getOperatorsList: (state, action) => {
      state.users = action.payload.users;
    },
  },
});

export const getOperatorsList = operatorSlice.actions.getOperatorsList;
export default operatorSlice.reducer;
